export const emptyComparator = () => 0;
